import {gql} from 'apollo-angular';

export const SCHOOL_CLASS_GAME_HISTORY = gql`
  query SchoolClassGameHistory($classCode: String!) {
    schoolClassGameHistory(classCode: $classCode) {
      schoolClassID
      points
      playtime
      createdAt
    }
  }
`;


